import styled from "styled-components";

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  height: 200px;
  width: 100%;
`;
